module.exports = __webpack_public_path__ + "img/107.6c3c67fe.svg";